import React from 'react'
import { SvgIcon, SvgIconProps } from '@material-ui/core'

export const MenuSvg = (props: SvgIconProps) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M3 6H21V8H3V6ZM3 11H21V13H3V11ZM3 16H21V18H3V16Z" fill="white" />
  </SvgIcon>
)
